import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, Row, Avatar, Typography,Col, Tag} from 'antd'
import {
    MailOutlined,
    PhoneOutlined,
    HomeOutlined

  } from '@ant-design/icons';
const {Title, Text} = Typography;

const MyProfile = () => {
    //const history = useHistory()
    const user = useSelector(state => state.user)
    const profile = useSelector(state => state.profile)



    return (
        <Card
            style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
        >
            <Row justify="center">
            {profile.avatarUrl 
                ? 
                <Avatar
                    size={{ xs: 80, sm: 80, md: 80, lg: 80, xl: 80, xxl: 80 }}
                    src={profile.avatarUrl}
                    
                ></Avatar>
                : 
                <Avatar
                    size={{ xs: 80, sm: 80, md: 80, lg: 80, xl: 80, xxl: 80 }}
                >
                    {profile.firstName.charAt(0) +  profile.lastName.charAt(0) }
                </Avatar>
            }
            </Row>
            <Row justify="center">
                <Title level={5}>{user.username}</Title>
            </Row>

            <Row justify="center">
                <Text >{profile.firstName} {profile.lastName}</Text>
            </Row>

            <Row justify="center" style={{marginTop:15}}>
                <Col span={6} style={{marginTop:5}} > 
                    <MailOutlined style={{float:"right"}}/>
                </Col>
                <Col span={17} style={{marginTop:3, marginLeft:5}} > 
                    <Text >{user.email}</Text>
                </Col>
                <Col span={6}  style={{marginTop:5}} > 
                    <PhoneOutlined style={{float:"right"}}/>
                </Col>
                <Col span={17} style={{marginTop:3, marginLeft:5}} > 
                    <Text >{profile.phoneNumber}</Text>
                </Col>
                <Col span={6}  style={{marginTop:5}} > 
                    <HomeOutlined style={{float:"right"}}/>
                </Col>
                <Col span={17} style={{marginTop:3, marginLeft:5}} > 
                    <Text >{profile.country}</Text>
                </Col>
            </Row>
        </Card>
    )
}

export default MyProfile
